import { WEAK_SEO } from '../../../constants/rulesConstants';
import { app } from '@/store';

const SPECIAL_CHARACTER = ['&nbsp;'];

export default class WeakSEO {
  static ruleId = WEAK_SEO.id;

  static validate() {
    const generalForm = app.$store.getters['page/generalForm'];
    let description: string = generalForm.description;
    let title = generalForm.title;
    SPECIAL_CHARACTER.forEach((character) => {
      description = description.replaceAll(character, '');
      title = title.replaceAll(character, '');
    });
    return description?.trim() && title?.trim();
  }
}
